import { handleActions } from 'redux-actions'

import {
    GET_ALL_EXPLOITATION_ORGANIZATIONS,
} from '@/store/actions/dictionaries'

const initialState = {
    data: [],
}

export const reducer = handleActions(
    {
        [GET_ALL_EXPLOITATION_ORGANIZATIONS.SUCCESS]: (state, { payload }) => ({
            ...state,
            data: payload,
        }),
        [GET_ALL_EXPLOITATION_ORGANIZATIONS.ERROR]: (state) => ({
            ...state,
        }),
    },
    initialState,
)

export default reducer